var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHouse2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 26,
    cy: 26,
    r: 26
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_1405_22050)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5985 22.7812H18.5328V37.9974H35.5985V22.7812Z",
    fill: "#926445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5985 22.7839H18.5328L14.2651 16.2604H31.3333L35.5985 22.7839Z",
    fill: "#D3BBAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2652 16.2604L18.5328 22.7839V38H10V22.7813L14.2652 16.2604Z",
    fill: "#C3855C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 30.3906H33.4672V27.1302H31.3333V30.3906Z",
    fill: "#8DD4FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7324 30.6634H31.0657V26.86H33.7324V30.6634ZM31.6036 30.1204H33.2046V27.3927H31.6036V30.1204Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 30.3906H22.798V27.1302H20.6641V30.3906Z",
    fill: "#8DD4FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0656 30.6634H20.399V26.86H23.0656V30.6634ZM20.9318 30.1204H22.5328V27.3927H20.9318V30.1204Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 33.6536H22.798V30.3932H20.6641V33.6536Z",
    fill: "#8DD4FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0656 33.9238H20.399V30.1204H23.0656V33.9238ZM20.9318 33.3808H22.5328V30.6634H20.9318V33.3808Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 33.6536H33.4672V30.3932H31.3333V33.6536Z",
    fill: "#8DD4FC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7324 33.9238H31.0657V30.1204H33.7324V33.9238ZM31.5985 33.3808H33.1995V30.6634H31.6036L31.5985 33.3808Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2677 30.3906H16.4016V27.1302H14.2677V30.3906Z",
    fill: "#FFDE0F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 30.6634H14V26.86H16.6667V30.6634ZM14.5328 30.1204H16.1313V27.3927H14.5328V30.1204Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1338 30.3906H14.2676V27.1302H12.1338V30.3906Z",
    fill: "#FFDE0F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5328 30.6634H11.8661V26.86H14.5328V30.6634ZM12.4116 30.1204H14.0126V27.3927H12.4116V30.1204Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1338 33.6536H14.2676V30.3932H12.1338V33.6536Z",
    fill: "#FFDE0F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5328 33.9238H11.8661V30.1204H14.5328V33.9238ZM12.399 33.3808H14V30.6634H12.4116L12.399 33.3808Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2677 33.6536H16.4016V30.3932H14.2677V33.6536Z",
    fill: "#FFDE0F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 33.9238H14V30.1204H16.6667V33.9238ZM14.5328 33.3808H16.1313V30.6634H14.5328V33.3808Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1995 27.1302H24.9318V38H29.1995V27.1302Z",
    fill: "#D3BBAF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4647 38H24.6667V26.86H29.4647V38ZM25.1995 38H28.9318V27.3927H25.1995V38Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1313 31.4792H27.0657V33.1107H28.1313V31.4792Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1995 23.8698H15.3333V21.6953H13.1995V23.8698Z",
    fill: "#8DD4FC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5985 24.1426H12.9318V21.4251H15.5985V24.1426ZM13.4646 23.597H15.0656V21.9681H13.4646V23.597Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9975 31.4792H35.5985V38H41.9975V31.4792Z",
    fill: "#C3855C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5985 31.4792H42L35.5985 27.1302V31.4792Z",
    fill: "#D3BBAF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8661 33.6511H37.7323V35.8255H39.8661V33.6511Z",
    fill: "#8DD4FC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1313 36.0983H37.4647V33.3809H40.1313V36.0983ZM37.9975 35.5553H39.5985V33.9238H37.9975V35.5553Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 13H20.1339V16.2604L23.3333 21.1523V13Z",
    fill: "#926445"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1995 13H26V16.2604L29.1995 21.1523V13Z",
    fill: "#926445"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1405_22050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 25,
    fill: "white",
    transform: "translate(10 13)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHouse2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/house2.8f9744a24235656f90b67ae238ee2bc4.svg";